import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function StickyMobileCTA() {
  const { subscribed } = useAuth();

  // Don't show for subscribed users
  if (subscribed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur border-t border-border md:hidden">
      <Link to="/auth" className="block">
        <Button size="lg" className="w-full gap-2 text-base font-semibold h-14 animate-pulse-glow">
          Get Started
          <ArrowRight className="w-5 h-5" />
        </Button>
      </Link>
      <p className="text-center text-xs text-muted-foreground mt-2">
        7-Day Money Back Guarantee
      </p>
    </div>
  );
}
